import { TestAttributeProps } from 'types/testAttribute';

import { Typography } from '../Typography';

import { ChipStyled } from './Chip.styles';
import { typographyVariant } from './styles';
import { ChipProps } from './types';

/**
 * Chip component.
 */
export const Chip = ({
  color,
  text,
  uppercase = true,
  variant = 'standard',
  datax,
}: ChipProps & TestAttributeProps) => (
  <ChipStyled
    className="chip"
    color={color}
    datax={datax}
    uppercase={uppercase}
    variant={variant}
  >
    <Typography className="chip-text" variant={typographyVariant[variant]}>
      {text}
    </Typography>
  </ChipStyled>
);
